// Per-tenant capabilities (MDG-105 phase 2). Filled once by FeatureFlagsService after the
// flag fetch; an absent flag or a failed fetch leaves a capability false.
export const features = {
  lotTracking: false,
  budgetsAndSavings: false,
  wishlistSoftBlock: false,
  emailSubscriptions: false,
  multiSellerCatalog: false,
  accountBucketPricing: false,
  termsGatedPricing: false,
  registrationDscsaRequired: false,
  marketplaceCheckout: false,
  marketplaceTerms: false,
  marketplaceListingEditor: false,
  marketplaceNavigation: false,
  bidOrders: false,
  rfpOrders: false,
  expeditedShipping: false,
};
export type FeatureKey = keyof typeof features;
